/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { get, find } from 'lodash';
import { RequestUtils } from '@broadleaf/admin-components/dist/metadata';
import { Environment } from '@broadleaf/admin-components/dist/common';

/**
 * Helper function to get data from a component's hydrate endpoint
 * @param {Object} metadata       Broadleaf metadata passed to field defining the hydrate URL
 * @param {Object} contextParams  Parameters necessary for the request obtained with a hook such as useProductContextParams
 * @returns {Promise}
 */
export const getHydrateData = async (metadata, contextParams) => {
  const endpoints = get(metadata, 'endpoints', []);
  const hydrateEndpoint = find(endpoints, { type: 'HYDRATE' });

  return RequestUtils.get({ ...hydrateEndpoint }, contextParams);
};

export function getSiteEnv() {
  return Environment.get('site.env', '') || import.meta.env.VITE_SITE_ENV;
}
